import { useMemo } from 'react';

const baseObjects = {
  date: {
    field: 'date',
    headerName: 'Date',
  },
  shift: {
    field: 'shift',
    headerName: 'Shift',
  },
  hours: {
    field: 'hours',
    headerName: 'Hours',
  },
  employee: {
    field: 'employee',
    headerName: 'Employee',
  },
  oogType: {
    field: 'oogType',
    headerName: 'OOG Type',
  },
  description: {
    field: 'description',
    headerName: 'Description',
  },
  total: {
    field: 'total',
    headerName: 'Total',
  },
  amount: {
    field: 'amount',
    headerName: 'Amount',
  },
};

const columns = {
  overtime: {
    emp: [baseObjects.date, baseObjects.shift, baseObjects.hours],
    date: [baseObjects.employee, baseObjects.shift, baseObjects.hours],
  },
  oog: {
    emp: [
      baseObjects.date,
      baseObjects.shift,
      baseObjects.oogType,
      baseObjects.hours,
    ],
    date: [
      baseObjects.date,
      baseObjects.employee,
      baseObjects.shift,
      baseObjects.oogType,
      baseObjects.hours,
    ],
  },
  town: {
    emp: [
      baseObjects.date,
      baseObjects.shift,
      baseObjects.description,
      baseObjects.hours,
    ],
    date: [
      baseObjects.employee,
      baseObjects.shift,
      baseObjects.description,
      baseObjects.hours,
    ],
  },
  private: {
    emp: [
      baseObjects.date,
      baseObjects.shift,
      baseObjects.description,
      baseObjects.hours,
    ],
    date: [
      baseObjects.employee,
      baseObjects.shift,
      baseObjects.description,
      baseObjects.hours,
    ],
  },
  stipendsSO: {
    emp: [
      baseObjects.date,
      baseObjects.shift,
      baseObjects.description,
      baseObjects.amount,
    ],
    date: [
      baseObjects.employee,
      baseObjects.shift,
      baseObjects.description,
      baseObjects.amount,
    ],
  },
};

export const useColumns = (type, groupby) => {
  return useMemo(() => {
    return columns[type][groupby.toLowerCase()];
  }, [groupby, type]);
};

export default useColumns;
